<template>
    <div>
        <div :class="['page join',{ off: !pageOn }]">
            <VHeader type="back" @back="pageOn = false;" />
            <div class="page-content">
                <img class="page-image" src="/join.png" />
                <div class="div-btns" :style="{ position: 'absolute', top: '0px', left: '0px' }">
                    <input class="i-name" placeholder="Enter Your Name" v-model="name" style="position: absolute;top:270px;left:48px;width:315px" />
                    <input placeholder="Enter Your Mobile Number" v-model="mobile" style="position: absolute;top:355px;left:48px;width:315px" />
                    <p @click="$emit('showTerms')" style="position:absolute;width:220px;height:30px;background-color:rgba(255,0,0,0);top:465px;left:120px"></p>
                    <p @click="join" style="position:absolute;width:345px;height:90px;background-color:rgba(255,0,0,0);top:510px;left:15px"></p>
                </div>    
                
                <!--
                <h1>Sign up for great offers</h1>
                <div class="ad-space">

                </div>

                <p class="btn lg" @click="join">Sign me up</p>
                <div class="verify">
                    <p><b>You must be over 18 to join</b></p>
                    <p>By signing up you agree to our<br><span @click="$emit('showTerms')">terms and conditions</span><br>You can unsubscribe at any time</p>
                </div>
                -->            
            </div>
        </div>
        <Already v-if="pages.indexOf('already') > -1" />
        <Sorry v-if="pages.indexOf('sorry') > -1" />
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { mapMutations } from 'vuex'
import { pageOn } from '@/utils/pageOn.js'
import Already from '@/components/Already.vue'
import Sorry from '@/components/Sorry.vue'
import WebSoc from '@/utils/WebSoc.js'
import Alert from '@/utils/Alert.js'

export default {
    name: 'join',
    mixins: [ pageOn ],
    components: {
        VHeader,
        Already,
        Sorry
    },
    computed: {
        pages () { return this.$store.state.pages },
        customer_id () { return this.$store.state.customer_id },
        phone () { return this.$store.state.phone },
        currentName () { return this.$store.state.name }
    },
    data () {
        return {
            name: '',
            mobile: ''
        }
    },
    watch: {
        phone ( newVal, oldVal ) {
            this.mobile = newVal;
        },
        currentName ( newVal, oldVal ) {
            this.name = newVal;
        }
    },
    mounted () {
        this.phone && ( this.mobile = this.phone); 
        this.currentName && ( this.name = this.currentName );
        var width = parseInt(getComputedStyle(this.$el.querySelector('.page-content')).width);
        this.$el.querySelector('.div-btns').style.transform = 'scale('+( width / 414 )+')';
    },
    methods: {
        join () {
            //console.log('join',this.name,this.mobile);
            WebSoc.SEND({ t: 'customerJoin', data: { fullPath: this.$route.fullPath, name: this.name, phone: this.mobile, customer_id: this.customer_id } },resp => {
                console.log('customerJoin',resp);
                if ( resp.error ) return Alert.message(resp.error);
                if ( resp.message ) return Alert.message(resp.message)
                this.popPage('join');
                this.pushPage('welcome');
            });
        },
        ...mapMutations(['pushPage','popPage'])
    }
}

</script>

<style lang="scss">
.join {
    p,h1 { color: #606060; }
    h1 { color: #606060; font-weight: 300; text-align: center; margin: 15px; font-size: 25px; }
    .ad-space {
        width: 100%;
        height: 100px;
        background-color: #606060;
        margin-bottom: 20px;
    }
    input {
        padding: 10px;
        margin: 20px 0px 20px calc(10% - 10px);
        width: calc(80% - 10px);
        &.i-name { margin-bottom: 0px; }
    }
    p.btn.lg {
        margin-top: 20px;
    }
    .verify {
        float: left;
        p:nth-child(1) {
            float: left;
            width: calc(100% - 30px);
            margin-top: 10px;
            text-align: center;
            font-size: 18px;
            b {
                font-weight: 700;
            }
        }
        p:nth-child(2) {
            margin-top: 5px;
            width: calc(100% - 30px);
            float: left;
            text-align: center;
            line-height: 1.5;
            font-size: 18px;
            font-weight: 300;
            span {
                margin: 5px 0px;
                float: left;
                width: 100%;
                text-decoration: underline;
            }
        }
    }
}
</style>